import { useState } from "react";
import { toast } from "sonner";
import { MessageSquare, Send } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { api, errMsg, fmtDate } from "@/lib/api";
import { cn } from "@/lib/utils";

export function OfferNotes({ offer, url, me, unread, onRead, onSent }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const notes = offer.notes || [];
  const toggle = () => { setOpen(!open); if (!open && unread && onRead) onRead(); };
  const send = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try {
      const r = await api.post(url, { text: text.trim() });
      toast.success(r.data.email_status === "sent" ? "Message sent and emailed" : "Message sent");
      setText(""); onSent();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-3 border-t border-slate-100 pt-3" data-testid={`offer-notes-${offer.id}`}>
      <button onClick={toggle} className="text-sm font-semibold flex items-center gap-2 text-slate-700 hover:text-slate-900" data-testid={`offer-notes-toggle-${offer.id}`}>
        <MessageSquare className="w-4 h-4" />Messages ({notes.length})
        {unread && <span className="px-2 py-0.5 rounded-full bg-amber-100 text-amber-800 text-xs" data-testid={`offer-notes-unread-${offer.id}`}>New reply</span>}
      </button>
      {open && <div className="mt-3 space-y-2">
        {notes.map((n) => (
          <div key={n.id || n.at} className={cn("rounded-lg px-3 py-2 text-sm max-w-[85%]", n.role === me ? "ml-auto bg-emerald-50 border border-emerald-100" : "bg-slate-50 border border-slate-200")} data-testid="offer-note">
            <div className="text-xs text-slate-500 mb-0.5">{n.by} · {n.role === "landlord" ? "Landlord" : "Agent"} · {fmtDate(n.at)} {new Date(n.at).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}</div>
            <p className="whitespace-pre-wrap">{n.text}</p>
          </div>))}
        {!notes.length && <p className="text-xs text-slate-400">No messages yet.</p>}
        <div className="flex gap-2 items-end">
          <Textarea rows={2} value={text} onChange={(e) => setText(e.target.value)} placeholder={me === "landlord" ? "Reply to your agent about this offer…" : "Message the landlord about this offer…"} data-testid={`offer-note-input-${offer.id}`} />
          <Button size="icon" disabled={busy || !text.trim()} onClick={send} className="bg-emerald-700 hover:bg-emerald-800 text-white shrink-0" data-testid={`offer-note-send-${offer.id}`}><Send className="w-4 h-4" /></Button>
        </div>
      </div>}
    </div>
  );
}
